import { useState, type KeyboardEvent, type ChangeEvent } from 'react';

import tigimIcon from 'images/tigim.svg';
import onClickPreventDefault from 'functions/general/onClickPreventDefault';
import validateEmail from 'functions/general/validateEmail';
import useFocus from 'hooks/useFocus';
import ModalSmall from './ModalSmall';
import {
  ModalBodySignIn,
  InputModal,
  FormDiv,
  LoginDiv,
  ButtonSignIn,
  ButtonLogIn
} from './elements';
import type { ModalForgotProps } from './types';

const ModalForgot = ({onClose, onSend, onReturn}: ModalForgotProps) => {
  const [email, setEmail] = useState<string>('');
  const [emailRef, setEmailFocus] = useFocus<HTMLInputElement>();

  const handleSend = () => {
    if (!validateEmail(email)) return setEmailFocus();
    onSend(email);
    onClose();
  };
  const onKeyPress = (e: KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter') {
      handleSend();
    }
  };
  return (
    <ModalSmall onClose={onClose}>
      <ModalBodySignIn onClick={onClickPreventDefault}>
        <button
          className="close"
          type="button"
          aria-label="Close"
          onClick={onClose}>
          <span aria-hidden="true">×</span>
        </button>
        <img src={tigimIcon} alt="tigim" />
        <h5>Password Recovery</h5>
        <FormDiv>
          <InputModal
            ref={emailRef}
            id="email"
            name="email"
            placeholder="Email"
            className={validateEmail(email)? '': 'empty'}
            value={email}
            onKeyPress={onKeyPress}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}/>
          <ButtonSignIn
            className={validateEmail(email)? 'active': 'inactive'}
            onClick={handleSend}>
            Recover password
          </ButtonSignIn>
          <LoginDiv>
            <ButtonLogIn onClick={onReturn}>
              Return to Login
            </ButtonLogIn>
          </LoginDiv>
        </FormDiv>
      </ModalBodySignIn>
    </ModalSmall>
  );
};

export default ModalForgot;
